import { render, staticRenderFns } from "./DataInputFilterExpressionRelation.vue?vue&type=template&id=2c774ab2&"
import script from "./DataInputFilterExpressionRelation.vue?vue&type=script&lang=js&"
export * from "./DataInputFilterExpressionRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports